import { render, staticRenderFns } from "./InventoryDropdown.vue?vue&type=template&id=147d1ba6&"
import script from "./InventoryDropdown.vue?vue&type=script&lang=js&"
export * from "./InventoryDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports